export const doesBooleanMatchSearch = (bool: string, search: string) =>
  !search.length || bool.toLowerCase().includes(search.toLowerCase());
